module.exports = __webpack_public_path__ + "img/7.bce9848e.png";